module.exports = require("./lib/polyfill");



//////////////////
// WEBPACK FOOTER
// ./~/babel-core/polyfill.js
// module id = 1979
// module chunks = 0